import { render, staticRenderFns } from "./MitigationDialog.vue?vue&type=template&id=97d137d2&scoped=true"
import script from "./MitigationDialog.vue?vue&type=script&lang=js"
export * from "./MitigationDialog.vue?vue&type=script&lang=js"
import style0 from "./MitigationDialog.vue?vue&type=style&index=0&id=97d137d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d137d2",
  null
  
)

export default component.exports